export const STATE_INITIALIZING = 0;
export const STATE_INITIALIZED = 1;
export const STATE_INTERACTING = 2;
export const STATE_INTERACTED_EMPTY = 3;
export const STATE_INTERACTED_NON_EMPTY = 4;